export function initAuthPasswordToggles() {
  document.querySelectorAll('[data-auth-password-toggle]').forEach(button => {
    const field = button.closest('.client-auth__password')?.querySelector('input');
    if (!field) {
      return;
    }

    button.addEventListener('click', () => {
      const shouldShow = field.type === 'password';
      field.type = shouldShow ? 'text' : 'password';
      button.classList.toggle('is-visible', shouldShow);
      button.setAttribute('aria-label', shouldShow ? 'Hide password' : 'Show password');
    });
  });
}
